import { Route, Routes } from "react-router-dom";
import Home from "./routes/Home";
import DiscoverPage from "./routes/DiscoverPage";
import MatchesPage from "./routes/Matches";
import MessagesPage from "./routes/Messages";
import ProfilePage from "./routes/Profile";
import HelpPage from "./routes/Help";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/matches" element={<MatchesPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/help" element={<HelpPage />} /> */}
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
